import { FC, JSX } from 'react';

import Modal from '@semcore/ui/modal';

import { Button } from '@/shared';
import { stopPropagation } from '@/shared/lib/utils/stopPropagation';
import { XIcon } from '@/shared/ui/icons/svgs/16';

import s from './Modal.module.css';

interface IRenderConfirmationModalProps {
  visible: boolean;
  onClose: () => void;
  renderVideo: () => void;
}

const RenderConfirmationModal: FC<IRenderConfirmationModalProps> = ({
  visible,
  onClose,
  renderVideo,
}): JSX.Element => {
  return (
    <Modal visible={visible} closable={false}>
      <Modal.Overlay onClick={onClose}>
        <Modal.Window className={s.window} onClick={stopPropagation}>
          <Modal.Close className={s.close} onClick={onClose}>
            <XIcon />
          </Modal.Close>
          <Modal.Title className="text-center">Render this video?</Modal.Title>

          <div className="mb-6 text-center font-light">
            You can keep configuring the player and overlay afterward. Video
            and audio tracks will be merged into a single file.
          </div>

          <div className="flex justify-center">
            <Button
              variant="primary"
              title="Render"
              size="sm"
              className="mr-2 py-2"
              disabled={false}
              onClick={renderVideo}
            />
            <Button
              variant="secondary"
              title="Cancel"
              size="sm"
              className="py-2"
              onClick={onClose}
            />
          </div>
        </Modal.Window>
      </Modal.Overlay>
    </Modal>
  );
};

export default RenderConfirmationModal;
